import React, { Fragment, useEffect, useMemo, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { TabContent, TabPane, Nav, NavItem, NavLink, Button, Modal, ModalHeader, ModalBody, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, Row, Col } from 'reactstrap';
import { NavLink as Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import { TransitionGroup, SwitchTransition, CSSTransition } from "react-transition-group";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import classNames from 'classnames';
import { List } from 'immutable';
import { teamActions, getCurrentTeam } from '../../../core/teams'
import { MIND_PATTERNS_DATA_AREAS, MIND_PATTERNS_DATA_REPORTS } from '../../../core/constants'
import { getCurrentTeamMembersList } from '../../../core/teams-members-list'
import { teamsReportListActions, getTeamsReportById } from '../../../core/teams-report'
import { teamsFullReportListActions, getCurrentTeamsFullReport } from '../../../core/teams-full-report'
import { questionsListActions } from '../../../core/questions-list'
import LoadingIndicator from '../../components/loading-indicator'
import { ThinkingTalents } from '../../components/teams'
import { TeamResume } from '../../components/teams/teamResume/TeamResume';
import { MindPatternsGroupedMembers } from '../../components/teams/mind-patterns-grouped-members';
import icon_members from '../../../assets/img/member-avatar.svg';
import addMemberBig from '../../../assets/img/addMemberBig.svg';
import { getMindPatternsDataById, mindPatternsDataActions } from '../../../core/mind-patterns';
import ThinkingTalentsFullReport from '../../components/teams/thinking-talents-full-report'
import { getCurrentTeamTopTalents, teamsTopTalentsListActions } from '../../../core/teams-top-talents-list';
import { teamResumeActions } from '../../../core/team-resume/actions';
import { MembersList } from '../../components/teams/members-list';
import { teamResumeStatsActions } from '../../../core/team-resume-stats';
import { MindPatternsTeamDistribution } from '../../components/teams/MindPatternsTeamDistribution';

const DetailPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { id: team_id } = useParams();
  const nodeRef = useRef(null);
  const tabsRef = useRef(null);
  const viewDetailRef = useRef(null);
  const viewTtReportRef = useRef(null);
  const viewMpReportRef = useRef(null);

  const user = useSelector(state => state.user);
  const quadrants = useSelector(state => state.quadrants);
  const questions = useSelector(state => state.questions);
  const team_resume_stats = useSelector(state => state.team_resume_stats);
  const team = useSelector(state => getCurrentTeam(state));
  const team_report = useSelector(state => getTeamsReportById(state, team_id));
  const team_full_report = useSelector(state => getCurrentTeamsFullReport(state));
  const team_members_list = useSelector(state => getCurrentTeamMembersList(state));
  const areas = useSelector(state => getMindPatternsDataById(state, MIND_PATTERNS_DATA_AREAS));
  const current_top_talents = useSelector(state => getCurrentTeamTopTalents(state));
  const members = team_members_list ? team_members_list.items : new List();

  const isAnyReduxStateLoading = (...states) => states.some(state => state?.isPending);
  const displayLoadingIndicator = useMemo(() => {
    return isAnyReduxStateLoading(
      team,
      team_members_list,
      team_full_report,
      team_report,
      current_top_talents,
      questions,
      team_resume_stats
    )
  }, [team, team_members_list, team_full_report, team_report, current_top_talents, questions, team_resume_stats])

  const [activeTab, setActiveTab] = useState(location?.state?.activeTab ? location?.state?.activeTab : 'overview');
  const [current_section, setCurrentSection] = useState('members-list');
  const [show_modal_delete, setShowModalDelete] = useState(false);
  const [current_section_report, setCurrentSectionReport] = useState('view-detail');

  const animationClass = {
    appearActive: 'animate__animated animate__slideInRight position-fixed',
    enter: 'animate__animated',
    enterActive: 'animate__animated animate__slideInRight position-fixed',
    exit: 'animate__animated',
    exitActive: 'animate__animated animate__slideOutLeft position-fixed',
  };
  const animationClassTabs = {
    enter: 'animate__animated',
    enterActive: 'animate__animated animate__fadeIn',
    exit: 'animate__animated',
    exitActive: 'animate__animated animate__fadeOut',
  };
  const animationClassReport = {
    appearActive: 'animate__animated animate__slideInRight position-relative',
    enter: 'animate__animated',
    enterActive: 'animate__animated animate__slideInRight position-relative',
    exit: 'animate__animated',
    exitActive: 'animate__animated animate__slideOutLeft position-absolute top-0 left-0',
  };

  useEffect(() => {
    if (!displayLoadingIndicator) {
      dispatch(teamResumeActions.loadTeamResume(team_id));
      dispatch(teamActions.loadTeam(team_id));
      dispatch(teamsReportListActions.loadTeamsReport(team_id));
      dispatch(mindPatternsDataActions.loadMindPatternsData(MIND_PATTERNS_DATA_REPORTS));
      dispatch(mindPatternsDataActions.loadMindPatternsData(MIND_PATTERNS_DATA_AREAS));
      dispatch(teamsTopTalentsListActions.loadTeamTopTalents(team_id));
      dispatch(questionsListActions.loadQuestions());
      dispatch(teamResumeStatsActions.loadTeamResumeStats(team_id));
    }
  }, [team_id]);

  const handleModalDelete = (e, confirm) => {
    if (confirm && show_modal_delete) {
      dispatch(teamActions.deleteTeam(team_id))
      navigate('/teams');
    }
    setShowModalDelete(!show_modal_delete);
  };

  const toggle = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setCurrentSectionReport('view-detail');
    }
  };

  const handleBack = (e) => {
    e.preventDefault();
    if (current_section_report !== 'view-detail') {
      setCurrentSectionReport('view-detail');
      return;
    }
    navigate('/teams');
  };

  const toggleSection = (section) => {
    setCurrentSectionReport(section);
    if (section === 'view-tt-report') {
      dispatch(teamsFullReportListActions.loadTeamsFullRepor(team.id))
    }
  };

  if (!team || (user.checked && !user.id))
    return <LoadingIndicator />;

  const enable_edit = (user && user.id === team.owner_id);

  return (
    <>
      <div className="container-fluid h-100">
        <div className="view overflow-hidden team-content h-100">
          <TransitionGroup component={null}>
            <CSSTransition nodeRef={nodeRef} classNames={animationClass} timeout={{ enter: 1000, exit: 1000 }} key={current_section} appear >
              <div ref={nodeRef} className="w-100 h-100 d-flex flex-column">
                <div className='mb-3 pt-md-4'>
                  <h1 className='mb-2 mb-lg-0 libre-caslon-text-regular h3-md h4'>Teams</h1>
                </div>

                <div className="position-relative d-flex justify-content-between align-items-center mb-3">
                  <Button color='link' onClick={e => handleBack(e)} className="p-0 text-body mr-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width={28} height={29} viewBox="0 0 28 29" fill='currentColor'>
                      <path d="M24.5,14.5c0,0.2-0.1,0.5-0.3,0.6c-0.2,0.2-0.4,0.3-0.6,0.3H6.5l6.4,6.4c0.1,0.1,0.1,0.2,0.2,0.3
                      c0,0.1,0.1,0.2,0.1,0.3s0,0.2-0.1,0.3c0,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.3-0.1
                      c-0.1,0-0.2-0.1-0.3-0.2l-7.9-7.9c-0.1-0.1-0.1-0.2-0.2-0.3c0-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.2,0.2-0.3
                      L11.6,6c0.2-0.2,0.4-0.3,0.6-0.3c0.2,0,0.5,0.1,0.6,0.3c0.2,0.2,0.3,0.4,0.3,0.6c0,0.2-0.1,0.5-0.3,0.6l-6.4,6.4h17.1
                      c0.2,0,0.5,0.1,0.6,0.3C24.4,14,24.5,14.3,24.5,14.5z"/>
                    </svg>
                  </Button>

                  <img className="media-object rounded-circle mr-2" width="36" height="36" src={team.image || icon_members} alt={team.name} />

                  <div className="flex-grow-1">
                    <h2 className="mb-0 h4 h3-md">{team.name}</h2>
                  </div>

                  <div className="ml-auto group-edit position-relative">
                    {current_section === 'members-list' &&
                      <UncontrolledDropdown>
                        <DropdownToggle color='outline-green-light' className='btn-sm'>
                          <FontAwesomeIcon size='sm' icon={faEllipsisV} className='mx-1' />
                        </DropdownToggle>
                        <DropdownMenu style={{ minWidth: '136px', marginRight: '10px' }}>
                          <DropdownItem tag={'div'} className='px-3' disabled={enable_edit === false ? true : false}>
                            <Link className="text-reset text-decoration-none" to={{ pathname: `/teams/${team.id}/edit` }} disabled={enable_edit === false ? true : false}>
                              <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 16 16" className='mr-2' fill='currentColor'>
                                <path d="M14.2,4.6l-2.8-2.8c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1-0.1-0.3-0.1-0.4-0.1s-0.3,0-0.4,0.1
                            c-0.1,0.1-0.2,0.1-0.3,0.2L2.3,9.5C2.2,9.6,2.1,9.7,2.1,9.8C2,9.9,2,10.1,2,10.2V13c0,0.3,0.1,0.5,0.3,0.7C2.5,13.9,2.7,14,3,14h2.8
                            c0.1,0,0.3,0,0.4-0.1c0.1-0.1,0.2-0.1,0.3-0.2L14.2,6c0.1-0.1,0.2-0.2,0.2-0.3c0.1-0.1,0.1-0.3,0.1-0.4s0-0.3-0.1-0.4
                            C14.4,4.8,14.3,4.7,14.2,4.6z M12,6.8L9.2,4l1.5-1.5l2.8,2.8L12,6.8z"/>
                              </svg> Edit Team
                            </Link>
                          </DropdownItem>
                          <DropdownItem className='p-0' tag={'div'} disabled={enable_edit === false ? true : false}>
                            <Button color='link' onClick={(e) => { e.preventDefault(); handleModalDelete() }} disabled={enable_edit === false ? true : false} className='text-danger px-3 text-decoration-none'>
                              <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 16 16" className='mr-2' fill="currentColor">
                                <path d="M13.5,3H11V2.5c0-0.4-0.2-0.8-0.4-1.1C10.3,1.2,9.9,1,9.5,1h-3C6.1,1,5.7,1.2,5.4,1.4S5,2.1,5,2.5V3H2.5
                              C2.4,3,2.2,3.1,2.1,3.1C2.1,3.2,2,3.4,2,3.5s0.1,0.3,0.1,0.4C2.2,3.9,2.4,4,2.5,4H3v9c0,0.3,0.1,0.5,0.3,0.7C3.5,13.9,3.7,14,4,14h8
                              c0.3,0,0.5-0.1,0.7-0.3S13,13.3,13,13V4h0.5c0.1,0,0.3-0.1,0.4-0.1C13.9,3.8,14,3.6,14,3.5s-0.1-0.3-0.1-0.4C13.8,3.1,13.6,3,13.5,3
                              z M7,10.5c0,0.1-0.1,0.3-0.1,0.4C6.8,10.9,6.6,11,6.5,11s-0.3-0.1-0.4-0.1C6.1,10.8,6,10.6,6,10.5v-4c0-0.1,0.1-0.3,0.1-0.4
                              C6.2,6.1,6.4,6,6.5,6s0.3,0.1,0.4,0.1C6.9,6.2,7,6.4,7,6.5V10.5z M10,10.5c0,0.1-0.1,0.3-0.1,0.4C9.8,10.9,9.6,11,9.5,11
                              s-0.3-0.1-0.4-0.1C9.1,10.8,9,10.6,9,10.5v-4c0-0.1,0.1-0.3,0.1-0.4C9.2,6.1,9.4,6,9.5,6s0.3,0.1,0.4,0.1C9.9,6.2,10,6.4,10,6.5
                              V10.5z M10,3H6V2.5c0-0.1,0.1-0.3,0.1-0.4C6.2,2.1,6.4,2,6.5,2h3c0.1,0,0.3,0.1,0.4,0.1C9.9,2.2,10,2.4,10,2.5V3z"/>
                              </svg>
                              Delete Team
                            </Button>
                          </DropdownItem>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    }
                  </div>
                </div>

                {/*TAB*/}
                <Fragment>
                  <Nav className="mb-3 mb-md-4 text-center nav-xs-justified align-items-end nav-tabs-alt" tabs>
                    <NavItem>
                      <NavLink className={classNames({ active: activeTab === 'overview', 'px-md-4 h5-md font-weight-semibold': true })} onClick={() => { toggle('overview'); }}>
                        Overview
                      </NavLink>
                    </NavItem>
                    <NavItem className="">
                      <NavLink className={classNames({ active: activeTab === 'members', 'px-md-4 h5-md font-weight-semibold': true })} onClick={() => { toggle('members'); }}>
                        Team Members {!team_resume_stats?.isPending ? `(${team_resume_stats?.count_members})` : ''}
                      </NavLink>
                    </NavItem>
                  </Nav>

                  <div className="content-tabs" style={{ overflow: 'hidden' }}>
                    <SwitchTransition>
                      <CSSTransition nodeRef={tabsRef} classNames={animationClassTabs} timeout={{ enter: 1000, exit: 300 }} key={activeTab} >
                        <div ref={tabsRef}>
                          <TabContent activeTab={activeTab}>
                            {/*OVERVIEW*/}
                            <TabPane tabId="overview" className='overflow-hidden position-relative'>
                              <TransitionGroup component={null} >
                                {current_section_report === 'view-detail' &&
                                  <CSSTransition nodeRef={viewDetailRef} classNames={animationClassReport} timeout={{ enter: 1000, exit: 1000 }} key={current_section_report}>
                                    <div ref={viewDetailRef} className='mx-md-n2 px-md-2 w-100'>
                                      {!displayLoadingIndicator && <TeamResume team={team} members={members} quadrants={quadrants} />}

                                      <div className="d-flex justify-content-between align-items-center pb-3">
                                        <h3 className="text-left h5 h4-md mb-lg-0">Thinking Talents Overview</h3>
                                        <Button color="green-light" size='sm' className="toggler-quadrants text-nowrap" onClick={() => toggleSection('view-tt-report')}>View Detail Report</Button>
                                      </div>
                                      <div className='talents-report mb-3'>
                                        <ThinkingTalents team={team} quadrants={quadrants} team_full_report={team_full_report} loadTeamsFullRepor={(id) => dispatch(teamsFullReportListActions.loadTeamsFullRepor(id))} questions={questions} team_report={team_report} />
                                      </div>

                                      {/*Mind Pattern Overview*/}
                                      {team_report &&
                                        <Row className='mb-3'>
                                          <Col lg={6} className='mb-3 mb-lg-0'>
                                            <div className="d-flex justify-content-between align-items-center pb-3">
                                              <h3 className="text-left h5 h4-md mb-lg-0">Mind Patterns Overview</h3>
                                              <Button color="green-light" size='sm' className="toggler-quadrants text-nowrap" onClick={() => toggleSection('view-mp-report')}>View Detail Report</Button>
                                            </div>
                                            <MindPatternsTeamDistribution distribution={team_report.mind_patterns_distribution} teamMP={team_report.mind_pattern} areas={areas} />
                                          </Col>
                                        </Row>
                                      }
                                    </div>
                                  </CSSTransition>
                                }

                                {current_section_report === 'view-tt-report' &&
                                  <CSSTransition nodeRef={viewTtReportRef} classNames={animationClassReport} timeout={{ enter: 1000, exit: 1000 }} key={current_section_report}>
                                    <div ref={viewTtReportRef} className='mx-md-n2 px-md-2 w-100'>
                                      <div className="d-flex align-items-center pb-3">
                                        <h3 className="text-left h5 h4-md mb-0">Thinking Talents Detail Report</h3>
                                      </div>
                                      <ThinkingTalentsFullReport team={team} questions={questions} team_full_report={team_full_report} />
                                    </div>
                                  </CSSTransition>
                                }

                                {current_section_report === 'view-mp-report' &&
                                  <CSSTransition nodeRef={viewMpReportRef} classNames={animationClassReport} timeout={{ enter: 1000, exit: 1000 }} key={current_section_report}>
                                    <div ref={viewMpReportRef} className='mx-md-n2 px-md-2 w-100'>
                                      <div className="d-flex align-items-center pb-3">
                                        <h3 className="text-left h5 h4-md mb-0">Mind Patterns Detail Report</h3>
                                      </div>

                                      <MindPatternsGroupedMembers mindPatternsGrouped={team_report?.mind_patterns_grouped_members} areas={areas} />
                                    </div>
                                  </CSSTransition>
                                }

                              </TransitionGroup>
                            </TabPane>

                            {/*MEMBERS*/}
                            <TabPane tabId="members">
                              {activeTab === "members" && <MembersList teamId={team.id} />}
                            </TabPane>
                          </TabContent>
                        </div>
                      </CSSTransition>
                    </SwitchTransition>
                  </div>
                </Fragment>

                {team_resume_stats?.count_members === 0 &&
                  <Fragment>
                    <div className='border rounded h-100 w-100 d-flex align-items-center justify-content-center flex-column'>
                      <img src={addMemberBig} width={78} alt='Add Member' className='mb-3' />
                      <p className='mb-4'>Currently, there are no members added. Click the button to add new members!</p>
                      {enable_edit &&
                        <Link to={`/teams/${team.id}/add-member`} className="btn btn-green-light btn-sm">
                          <svg xmlns="http://www.w3.org/2000/svg" width={15} height={15} viewBox="0 0 15 15" fill='currentColor' className='mt-n1'>
                            <path d="M14.5,7.9c0,0.2-0.1,0.3-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2h-0.4V9c0,0.2-0.1,0.3-0.2,0.5
                          c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2,0-0.3-0.1-0.5-0.2c-0.1-0.1-0.2-0.3-0.2-0.5V8.6h-0.4c-0.2,0-0.3-0.1-0.5-0.2
                          C11.1,8.3,11,8.1,11,7.9c0-0.2,0.1-0.3,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2h0.4V6.8c0-0.2,0.1-0.3,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2
                          c0.2,0,0.3,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5v0.4h0.4c0.2,0,0.3,0.1,0.5,0.2C14.4,7.6,14.5,7.8,14.5,7.9z M11.5,11
                          c0.1,0.1,0.2,0.3,0.2,0.5c0,0.2-0.1,0.3-0.2,0.4c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2,0-0.3-0.1-0.4-0.2c-0.7-0.9-2.1-2-4.1-2
                          c-1.6,0-3,0.7-4.1,2C2.2,12,2,12.1,1.9,12.1c-0.2,0-0.3,0-0.5-0.2c-0.1-0.1-0.2-0.3-0.2-0.4c0-0.2,0-0.3,0.2-0.5
                          C2,10.2,2.9,9.5,4,9.1c-0.6-0.5-1.1-1.2-1.3-2C2.4,6.3,2.4,5.5,2.7,4.7C3,3.9,3.5,3.2,4.1,2.8C4.8,2.3,5.6,2,6.4,2S8,2.3,8.7,2.8
                          c0.7,0.5,1.2,1.1,1.4,1.9c0.3,0.8,0.3,1.6,0.1,2.4c-0.2,0.8-0.7,1.5-1.3,2C9.9,9.5,10.8,10.2,11.5,11z M6.4,8.6c0.5,0,1-0.2,1.5-0.4
                          c0.4-0.3,0.8-0.7,1-1.2C9,6.5,9.1,6,9,5.5c-0.1-0.5-0.4-1-0.7-1.3C7.9,3.7,7.4,3.5,6.9,3.4c-0.5-0.1-1,0-1.5,0.1
                          c-0.5,0.2-0.9,0.5-1.2,1C3.9,4.9,3.8,5.4,3.8,6c0,0.7,0.3,1.4,0.8,1.9C5,8.3,5.7,8.6,6.4,8.6z"/>
                          </svg>
                          <span className='d-none d-md-inline-block pl-1'>Add Member</span>
                        </Link>
                      }
                    </div>
                  </Fragment>
                }

                {displayLoadingIndicator && <LoadingIndicator />}
              </div>
            </CSSTransition>
          </TransitionGroup>
        </div>
      </div>

      <Modal isOpen={show_modal_delete} toggle={handleModalDelete} className="pop-up-confirm">
        <ModalHeader close={<></>} toggle={handleModalDelete} className='justify-content-center border-0 pb-0' cssModule={{ 'modal-title': 'modal-title libre-caslon-text-regular h4 mt-3' }}>Delete Team?</ModalHeader>
        <ModalBody className='pt-3'>
          <p className='h5 font-weight-normal mb-4 text-center'>Are you sure you want to DELETE this team?</p>
          <div className="d-flex justify-content-center">
            <Button color="green-light" size="sm" className="mx-3" onClick={(e) => handleModalDelete(e, true)}>
              <svg xmlns="http://www.w3.org/2000/svg" width={15} height={15} viewBox="0 0 15 15" fill="currentColor" className='mr-2'>
                <path d="M12.3,3.1h-2V2.5c0-0.4-0.2-0.8-0.4-1.1C9.6,1.1,9.2,0.9,8.8,0.9H6.2c-0.4,0-0.8,0.2-1.1,0.4
                C4.8,1.7,4.7,2.1,4.7,2.5v0.7h-2c-0.2,0-0.3,0.1-0.5,0.2S2,3.6,2,3.8s0.1,0.3,0.2,0.5c0.1,0.1,0.3,0.2,0.5,0.2h0.2v7.4
                c0,0.3,0.1,0.6,0.3,0.8C3.4,12.9,3.7,13,4,13h7c0.3,0,0.6-0.1,0.8-0.3s0.3-0.5,0.3-0.8V4.4h0.2c0.2,0,0.3-0.1,0.5-0.2
                C12.9,4.1,13,4,13,3.8s-0.1-0.3-0.2-0.5C12.7,3.2,12.5,3.1,12.3,3.1z M6,2.5C6,2.4,6,2.4,6,2.3c0,0,0.1-0.1,0.2-0.1h2.6
                c0.1,0,0.1,0,0.2,0.1C9,2.4,9,2.4,9,2.5v0.7H6V2.5z M10.8,11.7H4.2V4.4h6.6V11.7z M6.8,6.2v3.5c0,0.2-0.1,0.3-0.2,0.5
                c-0.1,0.1-0.3,0.2-0.5,0.2s-0.3-0.1-0.5-0.2C5.6,10,5.5,9.9,5.5,9.7V6.2c0-0.2,0.1-0.3,0.2-0.5C5.8,5.6,6,5.5,6.2,5.5
                s0.3,0.1,0.5,0.2C6.8,5.8,6.8,6,6.8,6.2z M9.5,6.2v3.5c0,0.2-0.1,0.3-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2s-0.3-0.1-0.5-0.2
                C8.2,10,8.2,9.9,8.2,9.7V6.2c0-0.2,0.1-0.3,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2s0.3,0.1,0.5,0.2C9.4,5.8,9.5,6,9.5,6.2z"/>
              </svg>
              <span className="h6 font-weight-normal text-reset align-middle">Yes, Delete the Team</span>
            </Button>
            <Button color="outline-green-light" size="sm" className="mx-3" onClick={handleModalDelete}>
              <svg xmlns="http://www.w3.org/2000/svg" width={15} height={15} viewBox="0 0 15 15" fill='currentColor' className='mr-2'>
                <path d="M11.9,11c0.1,0.1,0.2,0.3,0.2,0.5c0,0.2-0.1,0.3-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2,0-0.3-0.1-0.5-0.2
                  L7.5,8.4L4,11.9c-0.1,0.1-0.3,0.2-0.5,0.2S3.2,12,3.1,11.9c-0.1-0.1-0.2-0.3-0.2-0.5c0-0.2,0.1-0.3,0.2-0.5l3.5-3.5L3.1,4
                  C3,3.9,2.9,3.7,2.9,3.6S3,3.2,3.1,3.1C3.2,3,3.4,2.9,3.6,2.9S3.9,3,4,3.1l3.5,3.5L11,3.1c0.1-0.1,0.3-0.2,0.5-0.2
                  c0.2,0,0.3,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5S12,3.9,11.9,4L8.4,7.5L11.9,11z"/>
              </svg>
              <span className="h6 font-weight-normal text-reset align-middle">No, Keep the Team</span>
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
}

export default DetailPage;